import React, { useEffect, useState, useRef } from 'react';
import { API_BASE_URL } from '../config';
import ReactMarkdown from 'react-markdown';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const blogRefs = useRef({});

  useEffect(() => {
    fetch(`${API_BASE_URL}/getBlogs.php`)
      .then(res => res.json())
      .then(res => {
        if (res.success) setBlogs(res.blogs);
        setLoading(false);
      });
  }, []);

  // Filter blogs by search
  const filteredBlogs = blogs.filter(blog =>
    blog.title.toLowerCase().includes(search.toLowerCase()) ||
    blog.content.toLowerCase().includes(search.toLowerCase())
  );

  // Scroll to blog by id
  const scrollToBlog = (id) => {
    if (blogRefs.current[id]) {
      blogRefs.current[id].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="container-fluid" style={{maxWidth: 1300}}>
      <h2 className="mb-4 text-center">NeeBun Blog</h2>
      <div className="row">
        {/* Summary/Sidebar */}
        <div className="col-12 col-md-4 col-lg-3 mb-4">
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search blog titles or content..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <h5>Blog Posts</h5>
          <ul className="list-group sticky-top" style={{top: 90, zIndex: 2}}>
            {filteredBlogs.map(blog => (
              <li key={blog.id} className="list-group-item d-flex justify-content-between align-items-center">
                <a href="#" onClick={e => { e.preventDefault(); scrollToBlog(blog.id); }}>
                  {blog.title}
                </a>
                <span className="badge bg-secondary">{new Date(blog.created_at).toLocaleDateString()}</span>
              </li>
            ))}
            {filteredBlogs.length === 0 && <li className="list-group-item text-muted">No blog found.</li>}
          </ul>
        </div>
        {/* Blog Content */}
        <div className="col-12 col-md-8 col-lg-9">
          {loading && <div>Loading...</div>}
          {!loading && filteredBlogs.length === 0 && (
            <div className="alert alert-info">No blog posts found.</div>
          )}
          {!loading && filteredBlogs.map(blog => {
            const blogUrl = `https://demosw.ganotras.in/blog/${blog.slug}`;
            return (
              <div key={blog.id} ref={el => blogRefs.current[blog.id] = el} className="mb-4 p-4 bg-white rounded shadow-sm">
                <h4>{blog.title}</h4>
                <small className="text-muted">{blog.author ? `By ${blog.author} | ` : ''}{new Date(blog.created_at).toLocaleDateString()}</small>
                <div className="mt-2">
                  <ReactMarkdown>{blog.content}</ReactMarkdown>
                </div>
                <div className="mt-3">
                  <span>Share: </span>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(blogUrl)}`}
                    target="_blank" rel="noopener noreferrer" className="me-2"
                    title="Share on Facebook"
                  >
                    <i className="bi bi-facebook"></i> Facebook
                  </a>
                  <a
                    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(blogUrl)}&text=${encodeURIComponent(blog.title)}`}
                    target="_blank" rel="noopener noreferrer" className="me-2"
                    title="Share on Twitter"
                  >
                    <i className="bi bi-twitter"></i> Twitter
                  </a>
                  <a
                    href={`https://wa.me/?text=${encodeURIComponent(blog.title + ' ' + blogUrl)}`}
                    target="_blank" rel="noopener noreferrer" className="me-2"
                    title="Share on WhatsApp"
                  >
                    <i className="bi bi-whatsapp"></i> WhatsApp
                  </a>
                  <a
                    href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(blogUrl)}&title=${encodeURIComponent(blog.title)}`}
                    target="_blank" rel="noopener noreferrer"
                    title="Share on LinkedIn"
                  >
                    <i className="bi bi-linkedin"></i> LinkedIn
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* Go to Top Button */}
      <button
        type="button"
        className="btn btn-light position-fixed"
        style={{right: 32, bottom: 92, zIndex: 9999, borderRadius: '50%', width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 8px rgb(19, 18, 18)' }}
        onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
        aria-label="Go to top"
      >
        <i className="bi bi-arrow-up" style={{fontSize: '1.5rem'}}></i>
      </button>
    </div>
  );
};

export default Blog;
